import { render, staticRenderFns } from "./BaseActionMenu.vue?vue&type=template&id=d595ab1e&"
import script from "./BaseActionMenu.vue?vue&type=script&lang=js&"
export * from "./BaseActionMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports